export interface IUserAdsInfo {
  userId: number;
  campaignId: UserAdsEnum;
  lastDisplayDate: string;
  id: number;
}

export enum UserAdsEnum {
  RATE = 'RATE',
  CAPACITY = 'CAPACITY',
  CO2 = 'CO2',
  TIACABLUESKYPROGRAM = 'TIACABLUESKYPROGRAM',
  TIACAMEMBERSHIP = 'TIACAMEMBERSHIP',
  PRINT_AWB = 'PRINT_AWB',
  NEW_COLOADERS = 'NEW_COLOADERS',
  RATE_MANAGEMENT_TOOL = 'RATE_MANAGEMENT_TOOL',
  MASKARGO = 'MASKARGO',
  QUALITYSCORE = 'QUALITYSCORE',
  QATAR_PHARMA_AD = 'QATAR_PHARMA_AD',
  ACE_EVENT = 'ACE_EVENT',
  NEW_YEAR_REVIEW = 'NEW_YEAR_REVIEW',
  CARGO_MART_PRO = 'CARGO_MART_PRO',
  EK_QR_WEIGHT_INC = 'EK_QR_WEIGHT_INC',
  CARGO_MART_PRO_2 = 'CARGO_MART_PRO_2',
  ACW_AWARDS = 'ACW_AWARDS',
  MODIFY_BOOKING = 'MODIFY_BOOKING',
  AIRLINE_UPDATE = 'AIRLINE_UPDATE',
  PRO_OPTION = 'PRO_OPTION',
  PRO_COPILOT = 'PRO_COPILOT',
  PRO_RATE_MOD = 'PRO_RATE_MOD',
  TRIAL_END = 'TRIAL_END',
  TRIAL_START = 'TRIAL_START',
  REGISTER_ACE = 'REGISTER_ACE',
  WALLET_PROMOTION = 'WALLET_PROMOTION',
  WALLET_PROMO_2025 = 'WALLET_PROMO_2025',
  COPILOT_PLUGIN = 'COPILOT_PLUGIN',
}
